import { Component, OnInit,Injector } from '@angular/core';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { RiesgoService } from '../../../services/riesgo/riesgo.service';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import Swal from "sweetalert2";
import { DatePipe } from "@angular/common";
import { Router,ActivatedRoute } from "@angular/router";
import {HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';

export const MY_FORMATS = {
  parse: {
    dateInput: "LL"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-reg-inversor',
  templateUrl: './reg-inversor.component.html',
  styleUrls: ['./reg-inversor.component.scss'],
  providers:[MessagesTitles, MessagesStatus,DatePipe , {
    provide: DateAdapter,
    useClass: MomentDateAdapter,
    deps: [MAT_DATE_LOCALE]
  },

  { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }]
})
export class RegInversorComponent implements OnInit {
  msgError : any;
  datos = {
    Num_Doc_Identificacion: "",
  }
  
  Id_IGV_No_Exonerado=environment.ID_IGV_No_Exonerado;
  empresa:any;
  loading: boolean = false;
  personaJuridica;
  departamento:any;
  provincia:any;
  distrito:any;
  depa:any;
  depafiltro:any;
  prov:any;
  provfiltro:any;
  dist:any
  distfiltro:any;
  titulo: string;
  editar: boolean = false;
  idEmpresa : string;
  form: FormGroup;
  user: any;
  DepaCombo: any;
  ProvCombo: any= [];
  DistCombo: any= [];
  tipoDocumentoElement : any;
  igvExoneradoElement : any=this.Id_IGV_No_Exonerado;
  depaNombre:any;
  provNombre:any;
  distNombre:any;
  riesgoService: RiesgoService 
  empresasService:EmpresasService
  loginService:LoginService
  constructor(
            private injector:Injector,
            private datePipe: DatePipe,
            private router: Router,private activateRoute :ActivatedRoute,
            private msgTitulos : MessagesTitles,
            private msgStatus:MessagesStatus
            ) {
    this.loginService = this.injector.get<LoginService>(LoginService);    
    this.riesgoService = this.injector.get<RiesgoService>(RiesgoService);
    this.empresasService = this.injector.get<EmpresasService>(EmpresasService);      
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.form = new FormGroup({
      TipoEmpresa: new FormControl('I', [Validators.required]),
      Razon_Social: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Num_Doc_Identificacion: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Nombre_Comercial: new FormControl('', [Validators.required]),
      Tipo_Doc_Identificacion: new FormControl(672, [Validators.required]),
      Direccion_Fiscal: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Departamento: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Provincia: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Distrito: new FormControl({ value: "", disabled: false }, [Validators.required]),
      Pais: new FormControl('', [Validators.required]),
      UBIGEO: new FormControl({ value: "010101", disabled: true }, ),
      Scoring_Puntaje: new FormControl({ value: "0", disabled: true }, [Validators.required]),
      Scoring_Fecha_Consulta: new FormControl({ value:  this.datePipe.transform(Date(),"yyyy-MM-dd"), disabled: true }, [Validators.required]),
      Estado: new FormControl({ value: "A", disabled: true }, [Validators.required]),
      Condicion: new FormControl('', ),
      IGV_Exonerado: new FormControl(this.igvExoneradoElement, [Validators.required]),
      Alta_Fecha: new FormControl('', ),
      Fecha_Adjuntos: new FormControl( this.datePipe.transform(Date(),"yyyy-MM-dd"), []),
      Alta_Canal: new FormControl('', []),
      Alta_Usuario: new FormControl('', []),
      Modificaion_Fecha: new FormControl('', []),
      Modificaion_Canal: new FormControl('W', []),
      Modificaion_Usuario: new FormControl('', []),
      PorcentajeIVA: new FormControl('0.70000', []),  
      Usuario: new FormControl(this.user.Usuario, [])
    });
    this.titulo = "Registro de Inversionista";
    this.tipoDocumentoElement = 672;
    this.activateRoute.params.subscribe( params => {
      if(params['id'] != undefined){
        this.titulo = "Editar Inversionista";
        
        this.editar = true;
        this.idEmpresa = params['id']; 
        
        this.loading = true;
        this.empresasService.obtenerInversoresByRuc(this.idEmpresa)
        .subscribe(res => { 
          this.empresa = res[0]
          this.departamento = res[0]['Departamento'];
          this.provincia = res[0]['Provincia'];
          this.distrito = res[0]['Distrito'];
          this.idEmpresa = res[0]['idEmpresa']; 
          this.form.controls['Num_Doc_Identificacion'].setValue(res[0]['Num_Doc_Identificacion']);
          this.form.controls['Num_Doc_Identificacion'].disable();
          this.form.controls['Razon_Social'].setValue(res[0]['Razon_Social']);
          this.form.controls['Scoring_Puntaje'].setValue(res[0]['Scoring_Puntaje']);
          this.form.controls['Nombre_Comercial'].setValue(res[0]['Nombre_Comercial']);
          this.form.controls['Tipo_Doc_Identificacion'].setValue(res[0]['Tipo_Doc_Identificacion']);
          this.form.controls['Direccion_Fiscal'].setValue(res[0]['Direccion_Fiscal']);
          this.form.controls['Pais'].setValue(res[0]['Pais']);
          this.form.controls['Departamento'].setValue(this.depafiltro);
          this.form.controls['Provincia'].setValue(this.provfiltro);
          this.form.controls['Distrito'].setValue(this.distfiltro);
          this.form.controls['IGV_Exonerado'].setValue(res[0]['IGV_Exonerado']);
          this.form.controls['Usuario'].setValue(this.user.Usuario);
          this.form.controls['Modificaion_Canal'].setValue('W');
          this.form.controls['Modificaion_Usuario'].setValue(this.user.Usuario);
          this.form.controls['Departamento'].setValue(res[0]['Departamento']);
          this.form.controls['Provincia'].setValue(res[0]['Provincia']);
          this.form.controls['Distrito'].setValue(res[0]['Distrito']);
          this.form.controls['PorcentajeIVA'].setValue(res[0]['PorcentajeIVA']);
          this.form.removeControl('Estado');
          this.form.removeControl('Condicion');          
          this.form.removeControl('Alta_Fecha');
          this.form.removeControl('Alta_Canal');
          this.form.removeControl('Alta_Usuario');
          this.form.controls['UBIGEO'].setValue(res[0]['UBIGEO']);
          this.form.removeControl('Scoring_Fecha_Consulta');
          this.loading = false;

          
          this.igvExoneradoElement = res[0]['IGV_Exonerado'];  
          this.tipoDocumentoElement = res[0]['Tipo_Doc_Identificacion'];  
          
      
        },(err: HttpErrorResponse)=> {
          this.loading = false;
          if (err.error instanceof ErrorEvent) {
            console.error("Error Event");
          } else {
              this.msgStatus.getMessage(err.status);            
          }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "CLIENTE NO OBTENIDO. "+this.msgStatus.message ,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        }); 
      }
    })
    
  }

  ngOnInit() {
    
    if(this.editar == false){
     /* this.empresasService.obtenerDepartamento().subscribe( resp => {
        this.DepaCombo= resp;
      },err => {
        console.log('err', err)
      });*/
    } 
    this.form.controls['IGV_Exonerado'].setValue(true);
  }
   
  
  cargarProvincia(idDepa: string){
    this.form.controls['Departamento'].setValue(idDepa);
    this.loading = true;
    this.empresasService.obtenerProvincia(idDepa).subscribe( resp => {
      this.ProvCombo= resp;
      this.loading = false;
    },err => {
      this.loading = false;
      console.log('err', err)
    });
  }
  cargarDistrito(idProv: string){
    this.form.controls['Provincia'].setValue(idProv);
    this.loading = true;
    this.empresasService.obtenerDistrito(idProv).subscribe( resp => {
      this.DistCombo= resp;
      this.loading = false;
    },err => {
      this.loading = false;
      console.log('err', err)
    });
  }

  setUbigeo(event){
    this.form.controls['Distrito'].setValue(event);
    this.form.controls['UBIGEO'].setValue(event);
  }
  
  tipoDocumento(event){
    this.form.controls['Tipo_Doc_Identificacion'].setValue(event);
  }

  igvExonerado(event){
    this.form.controls['IGV_Exonerado'].setValue(event);
  }

  crearFormulario(){
    
    if(this.editar){
      let cot = new FormControl({ value:  this.datePipe.transform(Date(),"yyyy-MM-dd"), disabled: true }, [Validators.required]);
      this.form.addControl('Scoring_Fecha_Consulta',cot);
      let cot2 = new FormControl({ value: "", disabled: true }, [Validators.required]);
      this.form.addControl('Estado',cot2);
     
    }else{
      this.form = new FormGroup({
        TipoEmpresa: new FormControl('I', [Validators.required]),
        Razon_Social: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Num_Doc_Identificacion: new FormControl('', [Validators.required ]),
        Nombre_Comercial: new FormControl('', [Validators.required]),
        Tipo_Doc_Identificacion: new FormControl(672, [Validators.required]),
        Direccion_Fiscal: new FormControl({ value: "", disabled: false }, [Validators.required]),
        Departamento: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Provincia: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Distrito: new FormControl({ value: "", disabled: true }, [Validators.required]),
        Pais: new FormControl('Perú', [Validators.required]),
        UBIGEO: new FormControl({ value: "", disabled: true }, []),
        Scoring_Puntaje: new FormControl({ value: "0", disabled: true }, [Validators.required]),
        Scoring_Fecha_Consulta: new FormControl({ value:  this.datePipe.transform(Date(),"yyyy-MM-dd"), disabled: true }, [Validators.required]),
        Estado: new FormControl({ value: "A", disabled: true }, [Validators.required]),
        Condicion: new FormControl('',),
        IGV_Exonerado: new FormControl(this.Id_IGV_No_Exonerado, [Validators.required]),
        Alta_Fecha: new FormControl('',),
        Fecha_Adjuntos: new FormControl( this.datePipe.transform(Date(),"yyyy-MM-dd"), []),
        Alta_Usuario : new FormControl("46780390", []),
        Adjunto_Ficha_Ruc : new FormControl("", []),
        Adjunto_Copia_Literal : new FormControl("", []),
        Alta_Canal : new FormControl("W", []),
        Modificaion_Fecha: new FormControl('', []),
        Modificaion_Canal: new FormControl('', []),
        Modificaion_Usuario: new FormControl('', []),
        Usuario: new FormControl("46780390", [])
      });
    }
  }

  validarNumDocumento() {

    if (this.form.controls['Num_Doc_Identificacion'].invalid) {
      Swal.fire({
        title: '¡Advertencia!',
        text:'El numero de identificación inválido.',
        type:'warning',
        allowOutsideClick:true,
        heightAuto: false
      });
    }
    else {
      this.loading = true;
      this.riesgoService.riesgoRUC(this.datos).subscribe(res => {
       if (res['message']) {
            this.loading = false;
            Swal.fire({
              title: '¡Advertencia!',
              text:'El numero de identificación no existe.',
              type:'warning',
              allowOutsideClick:true,
              heightAuto: false
            });
            this.crearFormulario();

          }else {
            
            this.personaJuridica = res;
            this.cargarCampos();
            
          }

      }, (err: HttpErrorResponse)=> {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
      } else {
          this.msgStatus.getMessage(err.status);            
      }
      Swal.fire({
        title: this.msgTitulos.Error,
        text: "RIESGO NO OBTENIDO. "+this.msgStatus.message,
        type: "error",
        allowOutsideClick: false,
        heightAuto: false
      });
      });
    }
  }
  

  cargarCampos() {
    this.loading= true;
    this.empresasService.obtenerDepartamento().subscribe( res => {
      this.DepaCombo= res;
      this.depa = this.DepaCombo.filter(depas => depas.cDesUBIGEO == this.personaJuridica.Departamento);
      if(this.depa.length > 0){
      this.depafiltro = this.depa[0].idUBIGEO;
      this.empresasService.obtenerProvincia(this.depafiltro).subscribe( resp => {
        this.ProvCombo= resp;
        this.prov = this.ProvCombo.filter(depas => depas.cDesUBIGEO == this.personaJuridica.Provincia)
        this.provfiltro = this.prov[0].idUBIGEO;
        this.empresasService.obtenerDistrito(this.provfiltro).subscribe( respu => {
          this.DistCombo= respu;
          this.dist = this.DistCombo.filter(depas => depas.cDesUBIGEO == this.personaJuridica.Distrito)
          this.distfiltro = this.dist[0].idUBIGEO;
          this.crearFormulario();
          this.form.controls['Scoring_Fecha_Consulta'].setValue(this.datePipe.transform(Date(),"yyyy-MM-dd"));

          this.form.controls['Num_Doc_Identificacion'].setValue(this.personaJuridica.Documento);
          this.form.controls['Razon_Social'].setValue(this.personaJuridica.RazonSocial);
          this.form.controls['Nombre_Comercial'].setValue(this.personaJuridica.RazonSocial);
          this.form.controls['Direccion_Fiscal'].setValue(this.personaJuridica.NomVia + " - " + this.personaJuridica.NumPredio);
          this.form.controls['Departamento'].setValue(this.depafiltro);
          this.form.controls['Provincia'].setValue(this.provfiltro);
          this.form.controls['Distrito'].setValue(this.distfiltro);
          this.form.controls['Scoring_Puntaje'].setValue(this.personaJuridica.ScoreBuro);
          this.form.controls['Tipo_Doc_Identificacion'].setValue(672);
          this.form.controls['UBIGEO'].setValue(this.distfiltro);
          switch (this.personaJuridica.EstadoContribuyente) {
            case 'ACTIVO':  this.form.controls['Estado'].setValue('A');
              
              break;
              case 'INHABILITADO-VENT.UNICA':  this.form.controls['Estado'].setValue('X');
              
              break;
          
            default:  this.form.controls['Estado'].setValue('B');
              break;
          }
          this.loading = false;
        },err => {
          this.loading = false;
          console.log('err', err)
        });
      },err => {
        this.loading = false;
        console.log('err', err)
      });
      }else{
        this.crearFormulario();
          this.form.controls['Scoring_Fecha_Consulta'].setValue(this.datePipe.transform(Date(),"yyyy-MM-dd"));
          this.form.controls['Num_Doc_Identificacion'].setValue(this.personaJuridica.Documento);
          this.form.controls['Razon_Social'].setValue(this.personaJuridica.RazonSocial);
          this.form.controls['Nombre_Comercial'].setValue(this.personaJuridica.RazonSocial);
          this.form.controls['Direccion_Fiscal'].setValue(this.personaJuridica.NomVia + " - " + this.personaJuridica.NumPredio);
          this.form.controls['Scoring_Puntaje'].setValue(this.personaJuridica.ScoreBuro);
          this.form.controls['Tipo_Doc_Identificacion'].setValue(672);
          this.form.controls['UBIGEO'].setValue(0);
          switch (this.personaJuridica.EstadoContribuyente) {
            case 'ACTIVO':  this.form.controls['Estado'].setValue('A');
              
              break;
              case 'INHABILITADO-VENT.UNICA':  this.form.controls['Estado'].setValue('X');
              
              break;
          
            default:  this.form.controls['Estado'].setValue('B');
              break;
          }
          this.loading = false;
      }
    },err => {
      console.log('err', err)
    });
  }

  guardarCambios(){
    console.log(this.form);
    if(this.form.invalid) {
      Swal.fire({
        title: '¡Formulario incompleto!',
        text:'Por favor completar todos los campos requeridos del formulario.',
        type:'info',
        allowOutsideClick:false,
        heightAuto: false
      });
      return;
    }
    Swal.fire({
          title: '¡Espere por favor!',
          text:'Estamos guardado la información.',
          type:'info',
          allowOutsideClick:false,
          heightAuto: false
        });
        Swal.showLoading();        
        if(this.editar){
          this.empresasService.actualizarEmpresa(this.idEmpresa, this.form.getRawValue())
          .subscribe( respu => {
            this.empresasService.obtenerListaProveedores().subscribe(res => {
              //sessionStorage.setItem('lstProvCbo',JSON.stringify( res));
              Swal.fire({
                title: "¡Éxito!",
                text: 'Cliente guardado correctamente.',
                type: "success",
                allowOutsideClick: false,
                heightAuto: false
              }).then( resp => {
                if (resp.value == true){ 
                  this.goBack();
                }
              })               
            });
          },(err: HttpErrorResponse)=> {
            this.msgStatus.getMessage(err.status); 
            this.loading = false;
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "NO SE ACTUALIZÓ EMPRESA. " + this.msgStatus.message,
            type: "error",
            allowOutsideClick: false,
            heightAuto: false
          });
          });
        }else{
          this.empresasService.registrarEmpresa(this.form.getRawValue())
          .subscribe( respu => {
            this.empresasService.obtenerProveedores().subscribe(res => {
              //sessionStorage.setItem('lstProvCbo',JSON.stringify( res));
              Swal.fire({
                title: "¡Éxito!",
                text: 'Cliente registrado correctamente.',
                type: "success",
                allowOutsideClick: false,
                heightAuto: false
              }).then( resp1 => {
                if (resp1.value == true){
                  this.goBack();
                }
              })               
            });
          },(err: HttpErrorResponse)=> {
            this.msgStatus.getMessage(err.status); 
        
          Swal.fire({
            title: "No se pudo registrar",
            text: "CLIENTE NO REGISTRADO. "+this.msgStatus.message,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          });
          });
        }
  }

  goBack(){
    this.loginService.clickGuard = true;
    this.router.navigate(['/empresas/inversor/listado']);
   }
   
}
